import React from 'react'
import { choicePage } from '../../../../pages/choicePage'
import { convertFugitiveNamesToChoiceArray } from '../../../../choices/convertFugitiveNamesToChoiceArray'
import { fugitive_names } from 'hotline_complaint_choices'

export const fugitiveName = choicePage({
  pageId: 'fugitive_name',
  pageTitle: 'Which HHS-OIG fugitive are you reporting?',
  pageDescription: (
    <span>
      Consult the list of{' '}
      <a href="https://oig.hhs.gov/fraud/fugitives/profiles.asp">
        HHS-OIG fugitives
      </a>{' '}
      for photographs and descriptions. This site is only for reports of HHS-OIG
      fugitives from this list.
    </span>
  ),
  fieldName: 'fugitive_name',
  fieldType: 'select',
  label: `Please select the fugitive's name`,
  choices: [{ label: '', value: '' }].concat(
    convertFugitiveNamesToChoiceArray(fugitive_names)
  )
})
